module.exports = __webpack_public_path__ + "static/media/card-img3.388a0a5f.webp";